// ---------- TYPES ----------
// ---------- FUNCTIONS ----------
export const flattenContentfulObject = (data) => {
    return {
        id: data.sys.id,
        ...data.fields
    };
};
//# sourceMappingURL=contentful.js.map